import logo from '../logo.svg';
import { Typography, Paper, AppBar, Button, Box, Card, CardActions, CardContent, CardMedia, CssBaseline, Grid, Link, Toolbar, Container } from '@mui/material';
import { HashLink } from 'react-router-hash-link';
import ResponsiveAppBar from './ResponsiveAppBar';
import Contactform from './Contactform';
import Footer from "./Footer";
import '../App.css';

const Imprint = () => {
  return (
    <div className="App">

<ResponsiveAppBar />

      <main>

        <Container maxWidth="lg" className="subPageContainer">
          <Typography variant='h1' className='sectionTitle'>Immobilie kaufen oder verkaufen</Typography>

          <Box className='subpageBodyBox'>
            <Typography variant='body1' className='sectionText'>
              Der erste Kauf einer Immobilie als Eigenheim oder als Kapitalanlage wirft oft viele Fragen auf. Unsere Aufgabe als Notare ist es, zeitnah einen Kaufvertragsentwurf zu erstellen und all Ihre Fragen im Beurkundungstermin zu beantworten. Im Anschluss stellen wir einen reibungslosen Übergang des Immobilieneigentums sicher.
            </Typography>

            <Button className='btnSecondary'><HashLink smooth to="#">Kaufvertrag online abwickeln</HashLink></Button>
          </Box>

          <hr className='hoeizontalLine' />

          
          <Box className='subpageBodyBox'>
            <Typography variant='body1' className='sectionText'>
              Wenn der Käufer den Kauf über einen Kredit bei einer Bank finanziert, wird die Bank eine Kreditsicherheit in Form einer Grundschuld verlangen. Auch die Bestellung der Grundschuld übernimmt der Notar. Dies kann regelmäßig unmittelbar im Anschluss an die Unterzeichnung des Kaufvertrages im gleichen Termin erfolgen.
            </Typography>

            <Button className='btnSecondary'><HashLink smooth to="#">Grundschuld online abwickeln</HashLink></Button>
          </Box>
        </Container>


<Box className="section bannergrey" id="kontakt">
          <Container maxWidth="lg" className="container" id="kontakt">
            <Box className="kontaktGrid">
              <Box className="kontaktLeftSide">
                <Typography variant='h2' className='sectionTitle white'>
                  Sie haben Fragen?  <br />
                  Wir stehen Ihnen gerne zur Verfügung und beantworten Ihr Anliegen in Kürze.
                </Typography>
                <Typography variant='body1' paragraph className='whiteText'>
                  Harbecke & Thelen Notare<br />
                  Holzgasse 29 - 33<br />
                  Siegburg 53721<br />
                </Typography>
              </Box>
              <Contactform />
            </Box>
          </Container>
        </Box>

        
      </main >
      <Footer />
    </div >
  );
}

export default Imprint;